import React from "react";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Integrations from "./components/Integrations/Integrations";
import Concept from "./components/Concept/Concept";
import Impact from "./components/Impact/Impact";
import Faq from "./components/Faq/Faq";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";

import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <Integrations />
        <Concept />
        {/* <WeatherSection /> */}

        {/* <Services /> */}
        <Impact />
        <Faq />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
